// 中文语言包
export default {
  // 通用文本
  common: {
    loading: '加载中...',
    error: '出错了',
    success: '成功',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    refresh: '刷新',
    close: '关闭',
    open: '打开',
    yes: '是',
    no: '否',
    currentLanguage: '当前语言',
    userAvatar: '用户头像',
    icon: '图标',
    arrow: '箭头',
    impact: '影响',
    detail: '详情',
    foodImage: '食物图片',
    codedImage: '健康定制图',
    volume: '音量',
    robot: 'AI机器人',
    assistant: 'AI助手',
    aiAvatar: 'AI头像',
    soundIcon: '声音图标',
    keyboard: '键盘',
    voice: '语音',
    send: '发送'
  },

  reportNavigation: {
    label: '报告页面导航',
    home: '返回报告首页',
    monthlyReport: '月度报告',
    tongueReport: '舌象报告',
    failed: '返回失败，请重试'
  },

  // 页面标题
  titles: {
    home: '健康报告',
    overview: '全部数据概览',
    details: '详情',
    nutrition: '营养素详情',
    nutritions: '营养素综合',
    tissue: '身体内脏',
    assess: '调理状态评估',
    scheme: '调理方案',
    recuperate: '调理详情',
    condition: '调理方案详情',
    compare: '健康评估比对',
    microelement: '微量元素',
    aiQuestionnaire: 'AI问卷',
    reportNumber: '报告编号',
    healthReport: '营养状态趋势报告',
    detectionReport: '营养状态趋势报告',
    // Overview 页面特有标题
    bodyHealthInfo: '身体状态参考信息',
    comprehensiveDataReport: '综合数据评估报告',
    dataDisclaimer: '数据为营养活力趋势参考，不作为医学检查依据',
    constitutionAssessment: '体质状态评估',
    constitutionAssessmentSubtitle: '（综合当前营养状态和基础体质，供参考）',
    nutritionAssessment: '营养素评估',
    constitutionEvaluation: '体质评估',
    bodyAssessment: '身体评估',
    nutritionDataReport: '营养素数据报表',
    bodyOrgansDataReport: '身体内脏数据报表',
    bodyComprehensiveDataReport: '身体综合数据报表'
  },

  // 健康相关
  health: {
    // 健康指标
    indicators: {
      liver: '肝相关状态',
      kidney: '肾相关状态',
      heart: '心相关状态',
      lung: '肺相关状态',
      spleen: '脾胃相关状态',
      stomach: '胃相关状态',
      intestine: '肠相关状态',
      brain: '脑相关状态',
      bone: '骨骼',
      muscle: '肌肉',
      blood: '血液',
      immune: '免疫系统',
      endocrine: '内分泌',
      nervous: '神经系统',
      reproductive: '生殖系统',
      urinary: '泌尿系统'
    },
    
    // 健康状态
    status: {
      normal: '参考区间',
      abnormal: '偏低关注',
      excellent: '偏高关注',
      good: '良好',
      average: '达标',
      fair: '一般',
      poor: '较差',
      critical: '严重',
      improving: '改善中',
      stable: '稳定',
      declining: '下降',
      // 器官状态相关
      healthy: '健康',
      subHealth: '亚健康',
      warning: '预警',
      risk: '风险',
      attention: '注意',
      maintain: '保持',
      strengthen: '加强',
      improve: '改善'
    }
  },

  // 营养相关
  nutrition: {
    // 营养素名称
    items: {
      vitaminA: '维生素A',
      vitaminB1: '维生素B1',
      vitaminB2: '维生素B2',
      vitaminB6: '维生素B6',
      vitaminB12: '维生素B12',
      vitaminC: '维生素C',
      vitaminD: '维生素D',
      vitaminE: '维生素E',
      vitaminK: '维生素K',
      folicAcid: '叶酸',
      niacin: '烟酸',
      biotin: '生物素',
      calcium: '钙',
      iron: '铁',
      zinc: '锌',
      magnesium: '镁',
      phosphorus: '磷',
      potassium: '钾',
      sodium: '钠',
      selenium: '硒',
      copper: '铜',
      manganese: '锰',
      iodine: '碘',
      chromium: '铬',
      molybdenum: '钼'
    },
    
    // 营养页面相关
    sections: {
      dynamicDataTracking: '动态数据跟踪',
      bodyAssociatedItems: '影响身体关联项',
      dietaryRecommendations: '饮食建议',
      exerciseRecommendations: '运动建议',
      lifestyleRecommendations: '起居建议',
      projectDescription: '项目说明',
      foodSources: '食物来源'
    },
    
    // 营养建议相关
    recommendations: {
      dietary: '饮食建议',
      exercise: '运动建议',
      lifestyle: '起居建议',
      dailyRoutine: '起居建议'
    },
    
    // 营养建议通用术语
    terms: {
      increase: '增加',
      decrease: '减少',
      maintain: '保持',
      avoid: '避免',
      consume: '摄入',
      supplement: '补充',
      balance: '平衡',
      moderate: '适量',
      daily: '每日',
      weekly: '每周',
      morning: '早晨',
      afternoon: '下午',
      evening: '晚上',
      beforeMeals: '餐前',
      afterMeals: '餐后',
      fruits: '水果',
      vegetables: '蔬菜',
      proteins: '蛋白质',
      carbohydrates: '碳水化合物',
      fats: '脂肪',
      fiber: '纤维',
      water: '水分',
      exercise: '运动',
      rest: '休息',
      sleep: '睡眠',
      stress: '压力',
      relaxation: '放松'
    }
  },

  // 图表相关
  charts: {
    // 图表元素
    elements: {
      initialValue: '初值',
      finalValue: '终值',
      currentValue: '当前值',
      targetValue: '目标值',
      averageValue: '平均值',
      maxValue: '最大值',
      minValue: '最小值',
      trend: '趋势',
      comparison: '对比',
      percentage: '百分比',
      score: '评分',
      level: '等级',
      range: '范围',
      unit: '单位',
      dynamicDataTracking: '动态数据跟踪',
      nutritionAssociation: '营养关联',
      organAssociation: '内脏关联',
      mainAssociationRatio: '主要关联比例',
      
      // 图例相关
      actualValue: '实测数值',
      standardValue: '标准数值',
      normalValue: '参考区间数值',
      excellentIndicator: '优良指标',
      needAttention: '需要关注',
      excellent: '优秀',
      
      // CircleProgress组件相关
      exceedUsers: '超越全国用户',
      bodyStatus: '身体状况',
      
      // GaugeCard组件相关
      nutritionBalanceIndicator: '营养均衡指标',
      nutritionStatus: '营养状况',
      imbalance: '失衡',
      insufficient: '不足',
      moderate: '适中',
      good: '良好',
      attention: '关注',
      
      // WaterfallCard组件相关
      nutritionVitalityTip: '营养活力提示',
      warningTip: '预警提示',
      qualifiedItems: '合格项目',
      abnormalValue: '偏低关注数值',
      
      // 提示框相关
      standard: '标准',
      measured: '实测',
      value: '数值',
      status: '状态'
    }
  },

  // 数据概览相关
  dataOverview: {
    detectionItem: '检测项目',
    initialValue: '初值',
    finalValue: '终值',
    averageValue: '均值',
    loadingText: '加载中...',
    vitamins: '维生素',
    microelements: '微量元素',
    minerals: '矿物质',
    warningCount: '预警项目',
    qualifiedCount: '合格项目',
    bodyDynamicChart: '身体综合检测动态图',
    organDynamicChart: '身体内脏检测动态图',
    nutritionDynamicChart: '营养素检测动态图',
    averageStatusChart: '平均值状态图',
    bodyAverageStatusChart: '身体综合平均值状态图',
    organAverageStatusChart: '身体内脏平均值状态图',
    nutritionAverageStatusChart: '营养素平均值状态图',
    comprehensiveDataTable: '综合数据报告表',
    organDataTable: '身体内脏数据报告表',
    nutritionDataTable: '营养素数据报告表',
    // Nutritions 页面专用
    nutritionStatusChart: '营养素状态图',
    detailedDataReportTable: '详细数据报告表',
    nutritionConditioningAdvice: '营养素调理建议'
  },

  // 操作按钮
  actions: {
    viewDetails: '查看详情',
    viewMore: '查看更多',
    startQuestionnaire: '开始问卷',
    downloadReport: '下载报告',
    downloadPdfReport: '下载PDF报告',
    shareReport: '分享报告',
    printReport: '打印报告',
    exportData: '导出数据',
    compareReports: '对比报告',
    scheduleAppointment: '预约检测',
    contactDoctor: '联系医生',
    viewHistory: '查看历史',
    updateProfile: '更新资料',
    viewHealthInfo: '查看身体状态参考信息',
    customSolution: '一键定制解决方案',
    viewFullHealthInfo: '查看全面健康信息',
    exerciseRecommendation: '运动建议',
    lifestyleRecommendation: '起居建议',
    bodyAssociatedItems: '影响身体关联项',
    nutritionAssociatedItems: '营养素关联项',
    view: '查看',
    expandMore: '展开更多',
    collapse: '收起'
  },

  // 调理方案相关
  conditioning: {
    scheme: '调理方案',
    schemeList: '调理方案列表',
    conditioningPlan: '调理方案',
    conditioningDetails: '调理详情',
    conditioningAdvice: '调理建议',
    conditioningRecommendation: '调理推荐',
    viewScheme: '查看方案',
    viewConditioning: '查看调理',
    planDescription: '方案描述',
    planDetails: '方案详情',
    implementationPlan: '实施方案',
    conditioningMethod: '调理方法',
    expectedEffect: '预期效果',
    attentionMatters: '注意事项',
    usageDuration: '使用周期',
    dosageInstructions: '用量说明',
    // Recuperate页面专用
    specialConditioningProject: '特色调理项目',
    conditioningExplanation: '调理说明',
    conditioningCycle: '调理周期',
    bodyMainConditioningItems: '身体主要调理项',
    nutritionMainConditioningItems: '营养素主要调理项',
    improvementProjectComparison: '提高项目对比图',
    detailedDataReportTable: '详细数据报告表',
    detectionItem: '检测项目',
    averageValue: '平均值',
    lastDetection: '上次检测',
    currentDetection: '本次检测',
    specialAttention: '特别注意'
  },

  // 评估页面相关
  assessment: {
    title: '调理状态评估',
    improvementProjectChart: '提高项目对比图',
    awaitImprovementChart: '有待提高项目比对图',
    dynamicComparisonChart: '动态比对图',
    interpretationTitle: '解读说明',
    lastDetection: '上次检测',
    currentDetection: '本次检测',
    lastInitialValue: '上次初值',
    lastFinalValue: '上次终值',
    currentInitialValue: '本次初值',
    currentFinalValue: '本次终值'
  },

  // 对比页面相关
  comparison: {
    title: '健康评估比对',
    before: '前',
    after: '后',
    improvementProjectChart: '提高项目对比图',
    awaitImprovementChart: '有待提高项目比对图',
    dynamicComparisonChart: '动态比对图',
    comparisonDataReportTable: '比对数据报告表',
    interpretationTitle: '解读说明',
    previousDetection: '前次检测',
    laterDetection: '后次检测',
    previousInitialValue: '前次初值',
    previousFinalValue: '前次终值',
    laterInitialValue: '后次初值',
    laterFinalValue: '后次终值',
    detectionItem: '检测项目',
    comparisonResult: '比对结果',
    improved: '已提升',
    needsImprovement: '待提升'
  },

  // 器官页面相关
  tissue: {
    projectDescription: '项目说明',
    dynamicTrackingMode: '动态跟踪模式',
    averageStatusChart: '平均值状态图',
    bodyAssociatedItems: '影响身体关联项',
    dietaryRecommendations: '饮食建议',
    exerciseRecommendations: '运动建议',
    lifestyleRecommendations: '起居建议',
    interpretationGuide: '解读说明'
  },

  // 用户信息相关
  user: {
    height: '身高',
    weight: '体重',
    age: '岁',
    bmi: 'BMI',
    bodyFatRatio: '体脂率',
    obesityIndex: '肥胖指数',
    heightUnit: 'cm',
    weightUnit: 'kg',
    bodyFatUnit: '%',
    defaultName: '苏大力'
  },

  // 健康状态相关
  healthStatus: {
    lifeFeature: '超越全国用户',
    bodyCondition: '身体状况',
    healthy: '健康',
    good: '良好',
    abnormal: '偏低关注',
    nutritionRisk: '营养失衡风险',
    healthRisk: '健康风险提示（脏器指标）',
    noAbnormalRisk: '暂无重点关注项',
    noAbnormalRiskFound: '暂无重点关注项'
  },

  // 弹窗相关
  dialogs: {
    interpretTitle: '解读说明',
    lifeFeatureTitle: '超越全国用户',
    lifeFeatureDesc: '表示您的健康状况超越了全国多少百分比的用户。该数值越高，表示您的身体状况相对更好。',
    bodyConditionTitle: '身体状况',
    bodyConditionDesc: '是指本次采集数据对应的身体状态参考结果。',
    bodyConditionHealthy: '健康：身体状态处于较好参考区间。',
    bodyConditionGood: '良好：身体状态处于参考区间，仍有提升空间。',
    bodyConditionAbnormal: '建议关注：身体状态存在需要持续观察的趋势。',
    bodyConditionHealthyDesc: '身体状态处于较好参考区间。',
    bodyConditionGoodDesc: '身体状态处于参考区间，仍有提升空间。',
    bodyConditionAbnormalDesc: '身体状态存在需要持续观察的趋势。',
    riskTitle: '风险说明',
    riskDesc: '营养均衡指标从0到1，数值越高表示营养状态越好。失衡（低于0.3）、参考区间（0.3-0.7）、偏高关注（高于0.7）。'
  },

  home: {
    messages: {
      openInMiniProgram: '请在小程序中打开',
      notInWechat: '错误：不在微信环境中，无法返回',
      notInMiniProgram: '错误：不在小程序环境中，无法返回',
      notInMiniProgramWebview: '错误：当前不在小程序web-view中，无法返回',
      returnSoon: '即将返回第三方小程序',
      returnFailed: '返回失败：{message}'
    }
  },

  // 分享相关
  share: {
    dialogTitle: '分享二维码',
    imageAlt: '分享二维码',
    loadImageFailed: '加载图片失败：{message}'
  },

  // 一键定制抽屉相关
  customSolutionDrawer: {
    titleMain: '请如实填写健康状况',
    titleSub: 'AI将智能调整配方，规避禁忌，提供专属产品方案',
    singleSectionTitle: '您的状态选择（单选）',
    multiSectionTitle: '是否存在以下情况？(可多选 / 可不选)',
    submitting: '提交中...',
    submit: '确认无误，生成安全方案',
    loadFailed: '加载失败，请重试',
    submitFailed: '提交失败，请重试'
  },

  // 一键定制加载页相关
  customSolutionLoader: {
    title: '根据您的身体状况',
    subtitle: '正在为您构建专属的每日营养补充方案'
  },

  // 月报页面相关
  monthlyReport: {
    trendTitle: '本月健康总分趋势',
    highestPoint: '周期内最高点',
    lowestPoint: '周期内最低点',
    averagePoint: '周期平均值',
    dailyAverage: '(日均)',
    aiInterpretation: 'AI智能解读：',
    monitoringStatsTitle: '您的{month}月度监测统计',
    daysUnit: '天',
    effectiveDays: '本月累计有效天数',
    monitoringTrack: '监测轨迹（{days}天）',
    focusTitle: '本周期健康焦点',
    declineTitle: '本周期重点关注',
    declineSubtitle: '状态下滑期',
    riseTitle: '本月亮点',
    riseSubtitle: '状态回升期',
    insightLabel: 'AI洞察：',
    totalScore: '总分数据',
    constitution: '体质',
    nutrition: '营养',
    improvementPathTitle: '您的下一个 30 天改善路径',
    improvementPathSubtitle: "基于本周期的'复盘'，您的下一个30天路径非常清晰：",
    disclaimer1: '本报告及所有建议仅供健康趋势参考',
    disclaimer2: '不能替代专业医疗机构意见',
    loadingStages: {
      stage1Title: '正在回溯本月监测数据',
      stage1Subtitle: '校验 4 个周切片连续性',
      stage2Title: 'AI 正在进行三维归因分析',
      stage2Subtitle: '扫描 16 项体质与 26 项营养素关联',
      stage3Title: '正在识别关键健康事件',
      stage3Subtitle: '分析趋势曲线与波动风险',
      stage4Title: '报告生成完毕',
      stage4Subtitle: '正在跳转...'
    },
    messages: {
      notInWechat: '错误：不在微信环境中，无法返回',
      notInMiniProgram: '错误：不在小程序环境中，无法返回',
      notInMiniProgramWebview: '错误：当前不在小程序web-view中，无法返回',
      returnSoon: '即将返回第三方小程序',
      returnFailed: '返回失败：{message}',
      submitFailed: '提交失败，请稍后重试',
      openInWechat: '请在微信中打开此页面',
      navigateFailed: '跳转失败，请稍后重试',
      lowestValue: '最低值',
      highestValue: '最高值'
    }
  },

  // 检测要求和注意事项
  requirements: {
    title: '监测要求和注意事项',
    item1: '1、本设备为非医疗器械健康管理辅助工具。监测前填写的健康问答会与测试数据形成个性化趋势参考，请认真填写。',
    item2: '2、报告中的提示项基于本次监测数据和算法分析生成，仅用于营养健康管理、生活方式改善和复测趋势参考。',
    item3: '3、报告中所提供的监测数据反映本次采集时的身体状态参考，在不同时段会受睡眠、运动、情绪、环境等因素影响而变化。',
    item4: '4、AI 小助手提供的信息和建议基于您的检测数据和公开健康知识库生成，仅作为健康管理参考。如有身体不适，请及时咨询专业医生。'
  },

  // AI解读相关
  aiInterpret: {
    title: 'AI营养助手解读本次营养状态趋势',
    titleHighlight: 'AI营养助手',
    titleSuffix: '解读本次营养状态趋势',
    keyResults: '关键监测结果',
    affectedConstitution: '建议关注的身体状态',
    importantTip: '重要提示：多项营养建议关注',
    multipleDeficiency: '发现多项营养状态建议关注项，请结合饮食、作息、运动综合管理',
    noKeyResults: '暂无关键监测结果数据',
    analyzing: '正在进行深度分析，请稍等片刻',
    generating: 'AI正在生成总结中...',
    currentLevel: '当前水平仅为',
    normalRange: '参考区间'
  },

  // 营养活力卡片相关
  nutritionVitality: {
    title: '营养活力提示',
    needAttention: '需要关注',
    excellentIndicator: '优良指标'
  },

  // 饮食建议相关
  dietAdvice: {
    title: 'AI调养建议',
    recentDietAdvice: '近期饮食建议',
    notRecommendedFoods: '种不推荐食材',
    recommendedFoods: '种推荐食材',
    reduceIntake: '建议减少摄入',
    recommendedSupplement: '推荐补充食物',
    noNotRecommendedFoods: '未见不推荐食材',
    lifestyleImprovement: '生活方式改善建议',
    dietAdviceDialog: '每日进行食物适应性测试，按照每日建议饮食定时定量，全面均衡，严禁食用不耐受食物。'
  },

  // AI助手相关
  aiAssistant: {
    title: 'AI营养助手',
    disclaimer: 'AI建议仅供营养健康管理参考，如有身体不适请咨询专业医生。',
    welcomeMessage: '嗨，我是盈养AI小助手！\n可以和我聊聊您对营养状态趋势报告的疑问，将为您解答各种问题！',
    inputPlaceholder: '向盈养AI小助手提问吧~',
    holdToSpeak: '按住说话',
    speakingTimeTooShort: '说话时间太短',
    waitForAIComplete: '请等待AI解读完成后再使用聊天功能',
    responseNotComplete: '回答未完成，稍等一下～',
    noMoreHistory: '没有更多历史消息了',
    loadingMore: '加载更多...',
    recordingCancelled: '录音已取消',
    recordingFailed: '录音失败，请重试',
    voiceRecognitionFailed: '语音识别失败，请重试',
    noSpeechDetected: '未识别到说话内容，请重试',
    releaseToCancel: '松开取消',
    releaseToSend: '松手发送 上移取消',
    errorResponse: '很抱歉未能回答（网络或问题限制）。建议：\n 1. 稍后重试 \n2. 检查网络 \n3. 换种提问方式 \n',
    recordingStartFailed: '录音启动失败，请检查权限：',
    microphonePermissionRequired: '需要录音权限才能使用语音功能',
    miniProgramInitializing: '小程序环境初始化中，请稍后重试',
    wechatInitializing: '微信功能初始化中，请稍后重试',
    wechatSDKInitFailed: '微信SDK初始化失败，请刷新页面重试',
    wechatVersionNotSupported: '当前微信版本不支持录音功能',
    grantMicrophonePermission: '请授予录音权限',
    recordingProcessFailed: '录音处理失败',
    recordingStopFailed: '录音停止失败，请重试',
    recordingNotSupported: '当前环境不支持录音功能',
    recordingDataError: '录音数据错误，请重试',
    stopRecordingIn: '{seconds} s 后停止语音'
  }
}
